import { axios } from 'lib/axios';

export const verifyPayment = ({ externalReference }) => {
  return axios.post(`/payments/verify/${externalReference}`);
};
